var parts = ['container', 'item', 'icon'];
var baseStyleContainer = {};
var baseStyleItem = {
  '::marker': {
    color: 'brand.500'
  }
};
var baseStyleIcon = {
  marginEnd: 4,
  display: 'inline',
  verticalAlign: 'text-bottom'
};
var baseStyle = {
  container: baseStyleContainer,
  item: baseStyleItem,
  icon: baseStyleIcon
};
export default {
  parts,
  baseStyle
};
//# sourceMappingURL=List.js.map